import OrderResource from 'App/resources/Order';
import RequestBuilder from 'Resources/RequestBuilder';
import ComparisonTypes from 'Resources/ComparisonTypes';
import type Order from 'App/resources/Model/Order';
import NotificationService from 'App/babel/NotificationService';
import T from 'Components/Helpers/translate';
import sendMail from './sendMail';

export default function sendMailFromOrders(rb: RequestBuilder) {
	rb.fields = ['id', 'contact'];
	rb.limit = 100;

	return OrderResource.find(rb.build()).then((res: { data: Order[] }) => {
		const uniqueContactIds = [
			...new Set(
				res.data.filter(order => order.contact?.id).map(order => order.contact!.id)
			)
		];

		if (!uniqueContactIds.length) {
			NotificationService.add({
				icon: 'times',
				style: NotificationService.style.ERROR,
				title: 'activity.outcome.couldNotSendMAil',
				body: 'mail.noValidRecipient'
			});
			return;
		}

		const skippedCount = res.data.filter(order => !order.contact?.id).length;
		if (skippedCount > 0) {
			NotificationService.add({
				icon: 'info-circle',
				style: NotificationService.style.INFO,
				title: 'default.sendEmail',
				body: T('mail.rowsWithoutContactSkipped', { count: skippedCount })
			});
		}

		const contactRb = new RequestBuilder();
		contactRb.addFilter({ field: 'id' }, ComparisonTypes.Equals, uniqueContactIds);
		return sendMail(contactRb);
	});
}
